import { NgModule } from '@angular/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { MatIconModule } from '@angular/material/icon';
import { TabApprovalsEquipmentsAttachmentsComponent } from './tab-approvals-equipments-attachments.component';

@NgModule({
    declarations: [
        TabApprovalsEquipmentsAttachmentsComponent
    ],
    imports     : [
        FuseSharedModule,
        MatIconModule
    ],
    exports: [
        TabApprovalsEquipmentsAttachmentsComponent
    ]
})
export class TabApprovalsEquipmentsAttachmentsModule { }
